<template>
  <div id="app">
    <RouterView name="default" />
  </div>
</template>

<script>
import i18n from '@/mixins/i18n'

export default {
  name: 'App',
  mixins: [i18n],
  props: {
    locale: {
      type: String,
      default: null
    }
  },
  beforeMount () {
    this.setLocale(this.$route.params.locale)
  },
  beforeRouteUpdate (to, from, next) {
    this.setLocale(to.params.locale)
    next()
  }
}
</script>


